"use client";

import type { SupWeb3TxSingleVault } from "@/types";
import { useEffect, useMemo } from "react";

import useTokenSuperpositionsBalances from "@/hooks/api/useTokenSuperpositionsBalances";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useStoredDataDispatch } from "@/store";

interface Web3DepositSuperPoolFinishedProps {
  transferTx: string | undefined;
  vaultList: SupWeb3TxSingleVault[];
}
export default function Web3DepositSuperPoolFinished({ vaultList, transferTx }: Web3DepositSuperPoolFinishedProps) {
  const storedDispatch = useStoredDataDispatch();
  const { network } = useDynamicContext();

  const singleVault = vaultList.length > 0 ? vaultList[0] : undefined;

  const { data: superPositionBalances } = useTokenSuperpositionsBalances("default");

  const singleSuperPosition = useMemo(() => {
    return superPositionBalances?.superPositions.find(superPosition => superPosition.vault.id === singleVault?.id && superPosition.is_erc20 && superPosition.chain_id === network);
  }, [superPositionBalances, singleVault?.id, network]);

  useEffect(() => {
    if (singleSuperPosition) {
      storedDispatch({
        type: "setTransmute",
        transmute: {
          superposition: singleSuperPosition,
          direction: "1155A",
          txLink: transferTx,
          source: "deposit",
        },
      });
      storedDispatch({ type: "clearCart" });
      storedDispatch({ type: "setOverlay", overlay: "transmute" });
    }
  }, [singleSuperPosition, storedDispatch, transferTx]);

  return <></>;
}
